export default {
    dialogs:{
        delete:'Вы действительно желаете удалить'
    },
    dialogsSettingsUsers: {
        delete_user: 'Удалить пользователя?'
    }
}